var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPpperspective(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 800 800",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "50%",
    x2: "50%",
    y2: "100%",
    gradientTransform: "rotate(45 .5 .5)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f46c38",
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f46c38",
    stopOpacity: 0,
    offset: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f46c38",
    shapeRendering: "crispEdges"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "0 578 289 289 289 511 0 800",
    fill: "url(#a)",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "0 800 289 511 511 511 222 800",
    fill: "url(#a)",
    opacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289,
    y: 289,
    width: 222,
    height: 222
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpperspective);
export default __webpack_public_path__ + "static/media/ppperspective.1cbbc2f6c4bfbd3b196381d7991ad14f.svg";
export { ForwardRef as ReactComponent };